//import components
import NewsItems from '../news/NewsItems';

export default function News() {
    return (
        <NewsItems homeNews />
    );
}